import React from 'react';

import EmbeddedGist from '../../components/common/embedded-gist/embedded-gist';

class ArticleBuilder {
  lastKey = 100;

  constructor(article) {
    this.article = article;
  }

  generateJSX() {
    this.iframeIndex = 0;

    return this.article.parts.slice(0, this.article.parts.length - 2).map((part) => {
      const html = this.generateJSXByPart(part);

      return (
        <div key={this.lastKey++} className='part'>{html}</div>
      );
    });
  }

  generateJSXByPart(part) {
    switch(part.type) {
      case 'paragraph': {
        return (
          <p dangerouslySetInnerHTML={{__html: part.content}}></p>
        );
      }
      
      case 'image': {
        return (
          <div className='figure-container'>
            <figure className='image-container'>
              <img 
                src={part.content.url} 
                alt={part.content.caption}
                title={part.content.caption} />

              <figcaption>{part.content.caption}</figcaption>
            </figure>
          </div>
        );
      }

      case 'iframe': {
        const iframeObject = this.article.iframes[this.iframeIndex++];

        switch (iframeObject.type) {
          case 'twitter': {
            return (
              <figure className='iframe-container embedded-tweet-container' dangerouslySetInnerHTML={{__html: iframeObject.html}}></figure>
            )
          }
          case 'gist': {
            return (
              <figure className='iframe-container gist-container'>
                <EmbeddedGist gist={iframeObject.gistId} />
                <figcaption>{part.caption}</figcaption>                
              </figure>
            )
          }
          case 'youtube': {
            return (
              <figure className='iframe-container youtube-container'>
                <iframe 
                  title={this.iframeIndex - 1}
                  width="560" 
                  height="315" 
                  src={`https://www.youtube.com/embed/${iframeObject.youtubeId}`} 
                  frameBorder="0" 
                  allowFullScreen>
                </iframe>

                <figcaption>{part.caption}</figcaption>                
              </figure>
              
            )
          }
          default: {
            break;
          }
        }

        return ('')
      }

      case 'link-preview': {
        let imgPart = '';
        
        if (part.content.imgLinkBackgroundStyle) {
          imgPart = (
            <div className='image-part'>
              <a
                href={part.content.url} 
                title={part.content.title} 
                target='_blank'
                style={{'backgroundImage': part.content.imgLinkBackgroundStyle}}>
              </a>
            </div>
          )
        }

        return (
          <div className='link-preview little-grow-animation'>
            <div className='textual-fields-part'>            
              <a href={part.content.url} title={part.content.title} target='_blank'>
                <div>
                  <div>
                    <div className='link-title'>{part.content.title}</div>
                    <div className='link-description'>{part.content.description}</div>
                    <div className='link-site-name'>{part.content.sourceName}</div>              
                  </div>
                </div>
              </a>
            </div>
            {imgPart}
          </div>
        );
      }

      case 'big-section-title': {
        return (
          <h4>{part.content}</h4>
        ); 
      }

      case 'little-section-title': {
        return (
          <h5>{part.content}</h5>
        ); 
      }      

      case 'big-citation': {
        return (
          <blockquote className='citation'>{part.content}</blockquote>
        );
      }

      case 'separator': {
        return (
          <hr className='article-part-separator' />
        );
      }

      case 'youtube': {
        return (
          <figure className='youtube'>
            {part.content.url}
            <figcaption>{part.content.caption}</figcaption>
          </figure>
        );
      }

      case 'code': {
        const divs = part.content.map((line) => {
          return (
            <div key={this.lastKey++}>{line}</div>
          )
        });

        return (
          <code className='plain-code'>
            {divs}
          </code>
        );
      }

      case 'list': {
        return (
          <ul dangerouslySetInnerHTML={{__html: part.content}}>
          </ul>
        );        
      }

      default: {
        return ('');
      }
    }
  }
}

export default ArticleBuilder;